import { Box } from '@mui/material';
import { CatalogCard } from '../../../../Shared/API/ApiTypes';
import Card from './Card';
import './CardsWrapper.css';


function CardsWrapper(props: { cards: CatalogCard[] }) {
  return (
    <Box sx={{ marginTop: '10px', overflow: 'hidden', borderRadius: 2, width: '100%' }}>
      {props.cards && props.cards.map((card, i) => {
        return <Card key={i} card={card} itemNumber={i} />
      })}
    </Box>
  );
}
export default CardsWrapper;